/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import MentorDropdown from './MentorDropdown';
import MenteesDropdown from './MenteesDropdown';

/**
 * Component for selecting mentor and mentees in forms
 * Combines both mentor and mentees dropdowns
 */
const MentorMenteesSelectionSection: React.FC = () => {
  return (
    <FormRow>
      <MentorDropdown />
      <MenteesDropdown />
    </FormRow>
  );
};

export default MentorMenteesSelectionSection;
